import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  addBackOfficeQuoteToCart,
  loadBackOfficeQuotes,
  removeQuoteMotoBackofficeFromCart,
  resetBackOfficeQuotes,
  updateTravelDataset,
  updateTravelGuarantee,
} from '../../../features/backofficeResults/backofficeResultsActions';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { confirmAlert, generalAlertError } from '../../../common/utils/alerts';
import { Layout } from '../components/Layout/Layout';
import { TravelQuotesStyles } from './TravelResultPage.styles';
import { AvvisoAlert } from '../../RcQuotes.styles';
import {
  RiskButton,
  RiskButtonRemove,
  RiskCard,
  RiskContainer,
  SelectFirstNotice,
} from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import GuaranteesSelectedCard from '../../../common/components/redesignComponents/Cards/GuaranteesSelectedCard';
import TravelCoverageModal from '../../TravelProduct/parts/TravelCoverageModal';
import TravelModal from '../../TravelProduct/parts/TravelModal';
import ProductInformationMondo from '../../TravelProduct/parts/ProductInformationMondo';
import ProductInformationEurope from '../../TravelProduct/parts/ProductInformationEurope';
import ProcessingQuoteSelectedTravel from '../../../common/components/redesignComponents/ResultPageComponents/ProcessingQuoteSelectedTravel';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import TravelSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/TravelSummaryCard';
import TravelQuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/TravelQuoteCostSummaryCard';
import FailedQuotationsComponent from '../../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function BackOfficeTravelQuotes() {
  const { requestToken } = useParams();
  const state = useSelector(
    (store) => store.backofficeResults.back_office_quotes,
  );
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const [modalExtensions, setModalExtensions] = useState([]);
  const isInfortuniCoverage = (id) => id === '000001_EA1358' || id === '000001_EA1244';
  const [loadingDataset, setLoadingDataset] = useState(false);
  const { register, watch, reset } = useForm({
    mode: 'all',
    defaultValues: {
      infortuni_data: {
        value: '',
        beneficario: '',
        contractor_id: '',
        insured_id: '',
      },
    },
  });
  const formData = watch();

  useEffect(() => {
    const selected = [];

    if (processingQuote !== null) {
      processingQuote.quotation_data_travel_europeassistance.coverages.forEach((ext) => {
        if (ext.enabled === 1) {
          processingQuote.quotation_coverages.forEach((q) => {
            if (ext.coverage_id === q.guarantees_slug) {
              selected.push(q.guarantees_slug);
            }
          });
        }
      });
    }

    setModalExtensions(selected);
  }, [processingQuote]);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, []);

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const getCoveragePrice = (coverage) => {
    const travelGuarantees = processingQuote.quotation_data_travel_europeassistance.coverages;
    const group = coverage.group_id !== null
      ? travelGuarantees.filter((c) => c.group_id === coverage.group_id)
      : [coverage];

    return group.reduce((price, cov) => price + cov.coverage_amount_gros, 0);
  };

  // Bagaglio and Bagaglio Top are mutually exclusive
  const handleGuarantees = async (val, closeId) => {
    const isAdding = !modalExtensions.includes(val);

    if (isAdding && isInfortuniCoverage(val)) {
      const { value, beneficario } = formData.infortuni_data;

      if (value !== '1' && !(value === '2' && beneficario !== '')) {
        generalAlertError('Seleziona Prima Beneficiario');
        return;
      }

      setLoadingDataset(true);
      await updateTravelDataset(requestToken, formData);
      setLoadingDataset(false);
      reset();
    } else if (!isAdding && isInfortuniCoverage(val)) {
      setLoadingDataset(true);
      await updateTravelDataset(requestToken, { infortuni_data: null });
      setLoadingDataset(false);
      reset();
    }

    const coverages = processingQuote.quotation_data_travel_europeassistance.coverages;
    let next;

    if (modalExtensions.includes(val)) {
      next = modalExtensions.filter((item) => item !== val);
    } else {
      next = [...modalExtensions, val];
      const title = coverages.find((el) => el.coverage_id === val).title.toLowerCase();
      const counterpartTitle = { bagaglio: 'bagaglio top', 'bagaglio top': 'bagaglio' }[title];
      const counterpart = counterpartTitle && coverages.find((cov) => cov.title.toLowerCase() === counterpartTitle);

      if (counterpart) {
        next = next.filter((item) => item !== counterpart.coverage_id);
      }
    }

    setModalExtensions(next);
    await updateTravelGuarantee(processingQuote.id, next, requestToken);
    const dismissButton = document.getElementById(closeId);

    if (dismissButton) {
      dismissButton.click();
    }
    fetchQuotes();
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteMotoBackofficeFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  return (
    <Layout>
      <div
        className="resultsPage"
        style={{
          width: '100%',
          maxWidth: '1200px',
          margin: 'auto',
          padding: '10px',
        }}
      >
        <V2FontImport />
        <TravelQuotesStyles>
          <div className="resultsPage">
            <ResultOverviewRow>
              <TravelSummaryCard
                insuranceRequest={requestInfo}
                customer={customer}
              />
              <TravelQuoteCostSummaryCard
                processingQuote={processingQuote}
                quoteTypes={quoteTypes}
                riskQuotations={risk_quotations}
                getTotal={getTotal}
              >
                {processingQuote?.quotation_data_travel_europeassistance.product_code === 'EA0177'
                  && <ProductInformationEurope processingQuote={processingQuote} />}
                {processingQuote?.quotation_data_travel_europeassistance.product_code === 'EA0190'
                  && <ProductInformationMondo processingQuote={processingQuote} />}
              </TravelQuoteCostSummaryCard>
            </ResultOverviewRow>
            {quotes && !quotes.res_civile
              && (
                <AvvisoAlert role="alert">
                  <h4>Avviso!</h4>
                  <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
                </AvvisoAlert>
              )}

            <RiskContainer className="mb-4">
              {[
                {
                  id: 'res_civile',
                  name: 'Responsabilità Civile',
                },
              ].map((type, index) => (
                <React.Fragment key={index}>
                  {quotes && quotes[type.id] && (
                    <RiskCard
                      className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${requestInfo.processing_quotation_id === null
                        && type.id !== 'res_civile'
                        ? 'bg-secondary bg-opacity-25'
                        : ''
                      } ${requestInfo.processing_quotation_id !== null
                          && type.id === 'res_civile'
                        ? 'bg-success bg-opacity-25'
                        : ''
                      } ${risk_quotations
                          && risk_quotations[type.id] !== undefined
                        ? 'bg-success bg-opacity-25'
                        : ''
                      }`}
                    >
                      <div className="me-auto">
                        <h5>
                          {type.id == 'res_civile' ? 'Viaggi' : type.name}
                        </h5>
                      </div>
                      {processingQuote !== null && type.id === 'res_civile' && (
                        <ProcessingQuoteSelectedTravel
                          processingQuote={processingQuote}
                          requestInfo={requestInfo}
                        />
                      )}

                      <div className="d-flex justify-content-end ms-auto gap-2">
                        {type.id === 'res_civile'
                          && processingQuote !== null && (
                            <RiskButtonRemove
                              className="btn btn-danger"
                              onClick={() => removeItemFromCart(processingQuote.id)}
                            >
                              Rimuovi
                            </RiskButtonRemove>
                        )}

                        {type.id === 'res_civile' && (
                          <RiskButton
                            className="btn btn-success"
                            data-bs-toggle="modal"
                            data-bs-target={`#${type.id}`}
                          >
                            Aggiungi
                          </RiskButton>
                        )}
                      </div>
                    </RiskCard>
                  )}
                </React.Fragment>
              ))}
              {processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.filter((f) => f.enabled === 1).map((coverage, index) => {
                const isSelected = processingQuote.quotation_coverages.find((el) => el.guarantees_slug === coverage.coverage_id) !== undefined;

                return (
                  <RiskCard
                    key={index}
                    className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${isSelected ? 'bg-success bg-opacity-25' : ''}`}
                  >
                    <div className="me-auto">
                      <h5>{coverage.title}</h5>
                    </div>
                    {isSelected && (
                      <div className="col-12 mb-2">
                        <GuaranteesSelectedCard
                          processingQuote={processingQuote}
                          requestInfo={requestInfo}
                          coverage={coverage}
                        />
                      </div>
                    )}

                    <div className="d-flex justify-content-end ms-auto gap-2">
                      {isSelected && (
                        <RiskButtonRemove
                          className="btn btn-danger"
                          onClick={() => handleGuarantees(coverage.coverage_id)}
                        >
                          Rimuovi
                        </RiskButtonRemove>
                      )}

                      {requestInfo.processing_quotation_id === null && (
                        <SelectFirstNotice>
                          Seleziona Prima Viaggi
                        </SelectFirstNotice>
                      )}

                      {!isSelected && requestInfo.processing_quotation_id !== null && (
                        <RiskButton
                          className="btn btn-success"
                          data-bs-toggle="modal"
                          data-bs-target={`#id_${coverage.coverage_id}`}
                        >
                          Aggiungi
                        </RiskButton>
                      )}
                    </div>
                  </RiskCard>
                );
              })}
            </RiskContainer>

            {[
              {
                id: 'res_civile',
                name: 'Responsabilità Civile',
              },
            ].map((type, index) => (
              <TravelModal
                key={index}
                type={type}
                addingQuote={addingQuote}
                quotes={quotes}
                requestToken={requestToken}
                insuranceRequest={requestInfo}
                selectQuotation={selectQuotation}
                fetchQuotes={fetchQuotes}
              />
            ))}
            {processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.filter((f) => f.enabled === 1).map((coverage, index) => (
              <TravelCoverageModal
                key={index}
                coverage={coverage}
                addingQuote={addingQuote}
                processingQuote={processingQuote}
                getCoveragePrice={getCoveragePrice}
                handleGuarantees={handleGuarantees}
                loadingDataset={loadingDataset}
                formData={formData}
                register={register}
                updateDataSet={() => { }}
              />
            ))}
          </div>
        </TravelQuotesStyles>
        {failedQuotes !== null && failedQuotes.length !== 0 && (
          <FailedQuotationsComponent failedQuotes={failedQuotes} />
        )}
      </div>
    </Layout>
  );
}

export default BackOfficeTravelQuotes;
